const router = {
  path: "/app/workOvertime",
  redirect: "app/workOvertime/draft",
  component: () => import("@/views/mainApp/components/workOvertimeApp/layout"),
  meta: {
    authRequired: true,
    hidden: true,
  },
  children: [
    {
      name: "approvedWorkOvertimesOfHr",
      path: "listWorkOvertimeCanUpdateOf-Hr",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/HRWorkOvertimeApproveds"
        ),
      props: true,
      meta: {
        appName: "approvedWorkOvertimesOfHr",
      },
    },
    {
      name: "approvedManagerWorkOvertimes",
      path: "manager",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/DMWorkOvertimesApproved"
        ),
      props: true,
      meta: {
        appName: "approvedManagerWorkOvertimes",
      },
    },
    {
      name: "myReportWorkOvertime",
      path: "myReport",
      component: () =>
        import("@/views/mainApp/components/workOvertimeApp/MyReport"),
      props: true,
      meta: {
        appName: "myReportWorkOvertime",
      },
    },
    {
      name: "statisticMonthForManager",
      path: "statistic-month-manager",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticMonthForManager"
        ),
      props: true,
      meta: {
        appName: "statisticMonthForManager",
      },
    },
    {
      name: "statisticMonthOTForReportDepartment",
      path: "statistic-month-report-department",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticMonthForReportDepartment"
        ),
      props: true,
      meta: {
        appName: "statisticMonthOTForReportDepartment",
      },
    },
    {
      name: "statisticYearForManager",
      path: "statistic-year-manager",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticYearForManager"
        ),
      props: true,
      meta: {
        appName: "statisticYearForManager",
      },
    },
    {
      name: "statisticYearOTForReportDepartment",
      path: "statistic-year-report-department",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticYearForReportDepartment"
        ),
      props: true,
      meta: {
        appName: "statisticYearOTForReportDepartment",
      },
    },
    {
      name: "statisticMonthDepartmentForHR",
      path: "statistic-month-hr/department",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticMonthDepartmentForHR"
        ),
      props: true,
      meta: {
        appName: "statisticMonthDepartmentForHR",
      },
    },
    {
      name: "totalOTThue",
      path: "total-ot-thue",
      component: () =>
        import("@/views/mainApp/components/workOvertimeApp/TotalOTThue"),
      props: true,
      meta: {
        appName: "totalOTThue",
      },
    },
    {
      name: "statisticYearDepartmentForHR",
      path: "statistic-year-hr/department",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticYearDepartmentForHR"
        ),
      props: true,
      meta: {
        appName: "statisticYearDepartmentForHR",
      },
    },
    {
      name: "statisticMonthEmployeeForHR",
      path: "statistic-month-hr/employee",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/StatisticMonthEmployeeForHR"
        ),
      props: true,
      meta: {
        appName: "statisticMonthEmployeeForHR",
      },
    },
    {
      name: "draftWorkOvertimes",
      path: "draft",
      component: () =>
        import("@/views/mainApp/components/workOvertimeApp/WorkOvertimeDrafts"),
      props: true,
      meta: {
        appName: "draftWorkOvertimes",
      },
    },
    {
      name: "editingWorkOvertimes",
      path: "editing",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeEditings"
        ),
      props: true,
      meta: {
        appName: "editingWorkOvertimes",
      },
    },
    {
      name: "submittingWorkOvertimes",
      path: "submitting",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeSubmittings"
        ),
      props: true,
      meta: {
        appName: "submittingWorkOvertimes",
      },
    },
    {
      name: "approvedWorkOvertimes",
      path: "approved",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeApproveds"
        ),
      props: true,
      meta: {
        appName: "approvedWorkOvertimes",
      },
    },
    {
      name: "rejectedWorkOvertimes",
      path: "rejected",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeRejecteds"
        ),
      props: true,
      meta: {
        appName: "rejectedWorkOvertimes",
      },
    },

    {
      name: "detailWorkOvertime",
      path: ":idWorkOvertime/detail",
      component: () =>
        import("@/views/mainApp/components/workOvertimeApp/WorkOvertimeDetail"),
      props: true,
    },
    {
      name: "detailWorkOvertimeDM",
      path: ":idWorkOvertime/detail-manager",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeDetailDM"
        ),
      props: true,
    },

    {
      name: "detailWorkOvertimeOfHr",
      path: ":idWorkOvertime/detail-hr",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/WorkOvertimeDetailHR"
        ),
    },

    {
      name: "viewWorkOvertime",
      path: ":idWorkOvertime/view",
      component: () =>
        import("@/views/mainApp/components/workOvertimeApp/WorkOvertimeView"),
      props: true,
    },
    {
      name: "waitingApprovalWorkOvertimes",
      path: "approvalWorkOvertime/waiting",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/ApprovalWorkOvertimeWaitings"
        ),
      props: true,
      meta: {
        appName: "waitingApprovalWorkOvertimes",
        appType: "approval",
        detailName: "detailApprovalWorkOvertime",
      },
      children: [
        {
          path: "/approvalWorkOvertime/waiting/:idWorkOvertime/approval",
          name: "detailApprovalWorkOvertime",
          component: () =>
            import(
              "@/views/mainApp/components/workOvertimeApp/components/approval/DetailWorkOvertimeApproval"
            ),
          meta: {
            appName: "waitingApprovalWorkOvertimes",
            appType: "approval",
            detailName: "detailApprovalWorkOvertime",
          },
          props: { isApproval: true },
        },
      ],
    },
    {
      name: "doneApprovalWorkOvertimes",
      path: "approvalWorkOvertime/done",
      component: () =>
        import(
          "@/views/mainApp/components/workOvertimeApp/ApprovalWorkOvertimeDones"
        ),
      props: true,
      meta: {
        appName: "doneApprovalWorkOvertimes",
        appType: "approval",
        detailName: "detailDoneApprovalWorkOvertime",
      },
      children: [
        {
          path: "/approvalWorkOvertime/done/:idWorkOvertime/approval",
          name: "detailDoneApprovalWorkOvertime",
          component: () =>
            import(
              "@/views/mainApp/components/workOvertimeApp/components/approval/DetailWorkOvertimeApproval"
            ),
          meta: {
            appName: "doneApprovalWorkOvertimes",
            appType: "approval",
            detailName: "detailDoneApprovalWorkOvertime",
          },
          props: { isApproval: false },
        },
      ],
    },
  ],
};

export default router;
